import React, { Suspense } from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyEventInformation = lazyWithRetry(() => import("./EventInformation"));

const EventInformation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyEventInformation {...props} />
  </Suspense>
);

export default EventInformation;
